// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__pNi9o","title":"ClientInsurance_title__2tD_p","itemText":"ClientInsurance_itemText__23dZh"};